import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { EBuildingClassType } from '../../../packages/api-models/common/json_query';

export const selectBuildingClassType = createSelector(
  selectJsonQuery,
  jsonQuery => getTermsValue('building_class_type')(jsonQuery) as EBuildingClassType[] | null,
);
